import { Button, Popover } from 'antd';
import React, { FC, useMemo } from 'react';
import { connect } from 'react-redux';
import { isUserManagedBySupplier } from '../../utils/AuthUtils';
import { ArrowRightOutlined, LockOutlined } from '@ant-design/icons';
import { SALES_LEAD_FORM_URL } from '../../utils/DataConstants';

const OWButtonWithSupplierManagedLock: FC<any> = ({
	children,
	currentUser,
	hideLockIcon,
	disabled,
	...props
}): React.ReactElement => {
	const isLocked = useMemo(() => isUserManagedBySupplier(currentUser), [currentUser]);

	const popoverContent = (
		<a href={SALES_LEAD_FORM_URL(currentUser)} target="_blank" rel="noopener ">
			Get access <ArrowRightOutlined size={12} />
		</a>
	);

	return (
		<Popover content={isLocked ? popoverContent : ''} trigger="hover">
			<Button {...props} disabled={isLocked || disabled}>
				{children ? children : null}
				{!hideLockIcon && isLocked ? (
					<span className="ml-2">
						<LockOutlined />
					</span>
				) : null}
			</Button>
		</Popover>
	);
};

const mapStateToProps = (state) => ({
	currentUser: state.session.currentUser,
});

export default connect(mapStateToProps)(OWButtonWithSupplierManagedLock);
